/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit'
import { loginAction, setAppTokens, setUserAction } from './actions'
import { AppTokens, User } from './types'

interface State {
  appTokens: AppTokens | null
  user: User | null
}

const initialState: State = {
  appTokens: null,
  user: null
}

export default createReducer(initialState, {
  [loginAction.type]: (_state, action) => ({
    token: action.payload.token,
    user: action.payload.user
  }),

  [setAppTokens.type]: (state, action) => {
    state.appTokens = action.payload
  },

  [setUserAction.type]: (state, action) => {
    state.user = action.payload
  }
})
